import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { TitleHeader } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import LoadingComponent from '../../components/LoadingComponent';
import AccessArrangementConfigurationDetails from './AccessArrangementConfigurationDetails';
import RouteKey from '../../routes/key';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const AccessArrangementConfiguration = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: userAuthoritiesData = [], isSuccess } = useGetUserAuthorities();

  useEffect(() => {
    if (!isSuccess) {
      return;
    }

    if (
      !userAuthoritiesData.includes(AUTHORITY_NAMES.CP_ADMIN_ACCESS_ARRANGEMENTS_CONFIGURATION_VIEW)
    ) {
      history.push(`/${error}/${generic}`);
    } else {
      setHasView(true);
    }
  }, [history, isSuccess, userAuthoritiesData]);

  return (
    <>
      <TitleHeader
        title={t('admin->>AccessArrangementConfiguration.AccessArrangementConfiguration')}
      />
      {hasView ? <AccessArrangementConfigurationDetails /> : <LoadingComponent />}
    </>
  );
};

export default AccessArrangementConfiguration;
